// src/layouts/trafficmonitoring/monitoring/data/fetchActiveEvents.js
import axios from "axios";
import config from "../../../../config";

const MAP_MATCHING_API_TOKEN = config.MAP_MATCHING_API_TOKEN;
const MAP_MATCHING_API_URL   = config.MAP_MATCHING_API_URL;

export async function fetchActiveEvents(data, endpoint) {
  try {
    const response = await axios.post(
      `${MAP_MATCHING_API_URL}${endpoint}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          "X-API-Key": MAP_MATCHING_API_TOKEN,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching route events:", error);
    return [];
  }
}
